module.exports = __webpack_public_path__ + "static/media/slebrity-nominate.80bf7dce.png";